import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import institutionOptions from "../data/institution_options.json";
import Select from "react-select";
import logger from "../utils/logger";

export default function ProfilePage() {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = userData.id;

  // Add badge-related state
  const [userBadges, setUserBadges] = useState([]);
  const [selectedBadges, setSelectedBadges] = useState([]);
  const [loadingBadges, setLoadingBadges] = useState(false);
  const [isVisible, setIsVisible] = useState(null);
  const [referralLink, setReferralLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [referralStats, setReferralStats] = useState(null);

  // Majors data for dropdown
  const majorsOptions = [
    { value: "computer-science", label: "Computer Science" },
    { value: "electrical-engineering", label: "Electrical Engineering" },
    { value: "mechanical-engineering", label: "Mechanical Engineering" },
    { value: "civil-engineering", label: "Civil Engineering" },
    { value: "chemical-engineering", label: "Chemical Engineering" },
    { value: "biomedical-engineering", label: "Biomedical Engineering" },
    { value: "aerospace-engineering", label: "Aerospace Engineering" },
    { value: "industrial-engineering", label: "Industrial Engineering" },
    { value: "materials-science", label: "Materials Science" },
    { value: "nuclear-engineering", label: "Nuclear Engineering" },
    { value: "environmental-engineering", label: "Environmental Engineering" },
    { value: "physics", label: "Physics" },
    { value: "chemistry", label: "Chemistry" },
    { value: "biology", label: "Biology" },
    { value: "mathematics", label: "Mathematics" },
    { value: "statistics", label: "Statistics" },
    { value: "economics", label: "Economics" },
    { value: "psychology", label: "Psychology" },
    { value: "sociology", label: "Sociology" },
    { value: "political-science", label: "Political Science" },
    { value: "history", label: "History" },
    { value: "philosophy", label: "Philosophy" },
    { value: "english", label: "English" },
    { value: "literature", label: "Literature" },
    { value: "linguistics", label: "Linguistics" },
    { value: "art-history", label: "Art History" },
    { value: "music", label: "Music" },
    { value: "theater", label: "Theater" },
    { value: "film-studies", label: "Film Studies" },
    { value: "architecture", label: "Architecture" },
    { value: "urban-planning", label: "Urban Planning" },
    { value: "landscape-architecture", label: "Landscape Architecture" },
    { value: "business-administration", label: "Business Administration" },
    { value: "finance", label: "Finance" },
    { value: "marketing", label: "Marketing" },
    { value: "accounting", label: "Accounting" },
    { value: "management", label: "Management" },
    { value: "entrepreneurship", label: "Entrepreneurship" },
    { value: "international-business", label: "International Business" },
    { value: "health-sciences", label: "Health Sciences" },
    { value: "nursing", label: "Nursing" },
    { value: "medicine", label: "Medicine" },
    { value: "pharmacy", label: "Pharmacy" },
    { value: "dentistry", label: "Dentistry" },
    { value: "veterinary-medicine", label: "Veterinary Medicine" },
    { value: "public-health", label: "Public Health" },
    { value: "epidemiology", label: "Epidemiology" },
    { value: "biostatistics", label: "Biostatistics" },
    { value: "neuroscience", label: "Neuroscience" },
    { value: "genetics", label: "Genetics" },
    { value: "biochemistry", label: "Biochemistry" },
    { value: "microbiology", label: "Microbiology" },
    { value: "immunology", label: "Immunology" },
    { value: "pharmacology", label: "Pharmacology" },
    { value: "toxicology", label: "Toxicology" },
    { value: "pathology", label: "Pathology" },
    { value: "radiology", label: "Radiology" },
    { value: "anesthesiology", label: "Anesthesiology" },
    { value: "surgery", label: "Surgery" },
    { value: "pediatrics", label: "Pediatrics" },
    { value: "psychiatry", label: "Psychiatry" },
    { value: "dermatology", label: "Dermatology" },
    { value: "cardiology", label: "Cardiology" },
    { value: "neurology", label: "Neurology" },
    { value: "oncology", label: "Oncology" },
    { value: "orthopedics", label: "Orthopedics" },
    { value: "ophthalmology", label: "Ophthalmology" },
    { value: "otolaryngology", label: "Otolaryngology" },
    { value: "urology", label: "Urology" },
    { value: "gynecology", label: "Gynecology" },
    { value: "obstetrics", label: "Obstetrics" },
    { value: "emergency-medicine", label: "Emergency Medicine" },
    { value: "family-medicine", label: "Family Medicine" },
    { value: "internal-medicine", label: "Internal Medicine" },
    { value: "geriatrics", label: "Geriatrics" },
    { value: "palliative-care", label: "Palliative Care" },
    { value: "hospice-care", label: "Hospice Care" },
    { value: "rehabilitation-medicine", label: "Rehabilitation Medicine" },
    { value: "sports-medicine", label: "Sports Medicine" },
    { value: "occupational-medicine", label: "Occupational Medicine" },
    { value: "preventive-medicine", label: "Preventive Medicine" },
    { value: "integrative-medicine", label: "Integrative Medicine" },
    { value: "alternative-medicine", label: "Alternative Medicine" },
    { value: "traditional-medicine", label: "Traditional Medicine" },
    { value: "naturopathic-medicine", label: "Naturopathic Medicine" },
    { value: "homeopathic-medicine", label: "Homeopathic Medicine" },
    { value: "ayurvedic-medicine", label: "Ayurvedic Medicine" },
    { value: "chinese-medicine", label: "Chinese Medicine" },
    { value: "acupuncture", label: "Acupuncture" },
    { value: "chiropractic", label: "Chiropractic" },
    { value: "osteopathic-medicine", label: "Osteopathic Medicine" },
    { value: "podiatric-medicine", label: "Podiatric Medicine" },
    { value: "optometry", label: "Optometry" },
    { value: "audiology", label: "Audiology" },
    { value: "speech-language-pathology", label: "Speech-Language Pathology" },
    { value: "occupational-therapy", label: "Occupational Therapy" },
    { value: "physical-therapy", label: "Physical Therapy" },
    { value: "respiratory-therapy", label: "Respiratory Therapy" },
    { value: "radiological-technology", label: "Radiological Technology" },
    {
      value: "medical-laboratory-science",
      label: "Medical Laboratory Science",
    },
    {
      value: "nuclear-medicine-technology",
      label: "Nuclear Medicine Technology",
    },
    { value: "radiation-therapy", label: "Radiation Therapy" },
    { value: "sonography", label: "Sonography" },
    {
      value: "magnetic-resonance-imaging",
      label: "Magnetic Resonance Imaging",
    },
    { value: "computed-tomography", label: "Computed Tomography" },
    {
      value: "positron-emission-tomography",
      label: "Positron Emission Tomography",
    },
    {
      value: "single-photon-emission-computed-tomography",
      label: "Single Photon Emission Computed Tomography",
    },
    { value: "ultrasound", label: "Ultrasound" },
    { value: "x-ray", label: "X-Ray" },
    { value: "fluoroscopy", label: "Fluoroscopy" },
    { value: "mammography", label: "Mammography" },
    { value: "bone-densitometry", label: "Bone Densitometry" },
    { value: "angiography", label: "Angiography" },
    { value: "venography", label: "Venography" },
    { value: "lymphangiography", label: "Lymphangiography" },
    { value: "myelography", label: "Myelography" },
    { value: "arthrography", label: "Arthrography" },
    { value: "sialography", label: "Sialography" },
    { value: "dacryocystography", label: "Dacryocystography" },
    { value: "other", label: "Other" },
  ];

  // Countries data for dropdown
  const countriesOptions = [
    { value: "United States", label: "United States" },
    { value: "Canada", label: "Canada" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Germany", label: "Germany" },
    { value: "France", label: "France" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Sweden", label: "Sweden" },
    { value: "Norway", label: "Norway" },
    { value: "Denmark", label: "Denmark" },
    { value: "Finland", label: "Finland" },
    { value: "Australia", label: "Australia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Japan", label: "Japan" },
    { value: "South Korea", label: "South Korea" },
    { value: "Singapore", label: "Singapore" },
    { value: "Hong Kong", label: "Hong Kong" },
    { value: "Israel", label: "Israel" },
    { value: "Austria", label: "Austria" },
    { value: "Belgium", label: "Belgium" },
    { value: "Ireland", label: "Ireland" },
    { value: "Italy", label: "Italy" },
    { value: "Spain", label: "Spain" },
    { value: "Portugal", label: "Portugal" },
    { value: "Poland", label: "Poland" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Hungary", label: "Hungary" },
    { value: "Estonia", label: "Estonia" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Croatia", label: "Croatia" },
    { value: "Romania", label: "Romania" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Greece", label: "Greece" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Malta", label: "Malta" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Iceland", label: "Iceland" },
    { value: "China", label: "China" },
    { value: "India", label: "India" },
    { value: "Brazil", label: "Brazil" },
    { value: "Mexico", label: "Mexico" },
    { value: "Argentina", label: "Argentina" },
    { value: "Chile", label: "Chile" },
    { value: "South Africa", label: "South Africa" },
    { value: "Turkey", label: "Turkey" },
    { value: "Russia", label: "Russia" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Belarus", label: "Belarus" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Thailand", label: "Thailand" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Philippines", label: "Philippines" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Qatar", label: "Qatar" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Oman", label: "Oman" },
    { value: "Jordan", label: "Jordan" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Egypt", label: "Egypt" },
    { value: "Morocco", label: "Morocco" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Algeria", label: "Algeria" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Kenya", label: "Kenya" },
    { value: "Ghana", label: "Ghana" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Uganda", label: "Uganda" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Botswana", label: "Botswana" },
    { value: "Namibia", label: "Namibia" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
    { value: "Malawi", label: "Malawi" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Colombia", label: "Colombia" },
    { value: "Peru", label: "Peru" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Guyana", label: "Guyana" },
    { value: "Suriname", label: "Suriname" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Panama", label: "Panama" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Honduras", label: "Honduras" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Belize", label: "Belize" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
    { value: "Barbados", label: "Barbados" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "Haiti", label: "Haiti" },
    { value: "Cuba", label: "Cuba" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Armenia", label: "Armenia" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Côte d'Ivoire", label: "Côte d'Ivoire" },
    {
      value: "Democratic Republic of the Congo",
      label: "Democratic Republic of the Congo",
    },
    { value: "Georgia", label: "Georgia" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Iraq", label: "Iraq" },
    { value: "Iran", label: "Iran" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Libya", label: "Libya" },
    { value: "Macedonia", label: "Macedonia" },
    { value: "Moldova", label: "Moldova" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Nepal", label: "Nepal" },
    { value: "North Korea", label: "North Korea" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palestine", label: "Palestine" },
    { value: "Serbia", label: "Serbia" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Syria", label: "Syria" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Yemen", label: "Yemen" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    interests: [],
    preferredCountries: [],
    resumeKey: "",
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    firstLanguage: "",
    citizenship: "",
    linkedinUrl: "",
    greVerbal: "",
    greQuantitative: "",
    greWriting: "",
    toeflReading: "",
    toeflListening: "",
    toeflSpeaking: "",
    toeflWriting: "",
    ieltsListening: "",
    ieltsReading: "",
    ieltsWriting: "",
    ieltsSpeaking: "",
    ieltsOverall: "",
    englishScore: "",
    professorInstitution: "",
    customInstitution: "",
    professorDepartment: "",
    professorCollege: "",
    professorRank: "",
    professorWebPage: "",
  });

  const [interestsText, setInterestsText] = useState(
    Array.isArray(formData.interests) ? formData.interests.join(", ") : ""
  );

  // Education history state
  const [educationEntries, setEducationEntries] = useState([
    {
      level: "undergraduate",
      institution: "",
      department: "",
      customDepartment: "",
      customInstitution: "",
      gpa: "",
      gpaScale: "",
      graduationYear: "",
      isCompleted: false,
    },
  ]);
  const [resumeFile, setResumeFile] = useState(null);
  const [resumeLink, setResumeLink] = useState(null);

  // Check if profile is complete
  const isProfileComplete = () => {
    const hasBasicInfo = Boolean(formData.name?.trim());
    const hasInterests = Boolean(formData.interests?.length > 0);

    if (userData.role === "student") {
      const hasValidEducation = educationEntries.some((entry) => {
        const hasInstitution = entry.institution?.trim();
        const hasCustomInstitution =
          entry.institution === "Other"
            ? entry.customInstitution?.trim()
            : true;
        const hasDepartment = entry.department?.trim();
        const hasCustomDepartment =
          entry.department === "other" ? entry.customDepartment?.trim() : true;
        return (
          hasInstitution &&
          hasCustomInstitution &&
          hasDepartment &&
          hasCustomDepartment
        );
      });
      const hasResume = Boolean(formData.resumeKey?.trim());
      return hasBasicInfo && hasValidEducation && hasInterests && hasResume;
    } else if (userData.role === "professor") {
      // For professors, we don't require education history, just basic info and interests
      return hasBasicInfo && hasInterests;
    } else {
      // For other roles (admin), just basic info and interests
      return hasBasicInfo && hasInterests;
    }
  };

  // Helper function to check if a section is complete
  const isSectionComplete = (sectionName) => {
    switch (sectionName) {
      case "personal":
        return Boolean(formData.name?.trim());
      case "education":
        if (userData.role === "professor") {
          // For professors, education section is always complete since we don't require it
          return true;
        }
        return educationEntries.some((entry) => {
          const hasInstitution = entry.institution?.trim();
          const hasDepartment = entry.department?.trim();
          const hasCustomDepartment =
            entry.department === "other"
              ? entry.customDepartment?.trim()
              : true;
          return hasInstitution && hasDepartment && hasCustomDepartment;
        });
      case "professorInfo":
        // For professors, this section is always complete since fields are optional
        return true;
      case "preferences":
        return Boolean(formData.interests?.length > 0);
      case "resume":
        return userData.role === "student"
          ? Boolean(formData.resumeKey?.trim())
          : true;
      default:
        return false;
    }
  };

  // Helper function to get section status style
  const getSectionStatusStyle = (sectionName) => {
    const isComplete = isSectionComplete(sectionName);
    return {
      backgroundColor: isComplete ? "#10B981" : "#EF4444",
      color: "#FFFFFF",
      padding: "0.25rem 0.75rem",
      borderRadius: "9999px",
      fontSize: "0.75rem",
      fontWeight: "600",
      marginLeft: "0.5rem",
    };
  };

  // Helper function to check if department is "Other" and show custom input
  const isDepartmentOther = (department) => {
    return department === "other";
  };

  // Add function to fetch user badges
  const fetchUserBadges = async () => {
    if (userData.role !== "student") return;

    setLoadingBadges(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/badges/user/${userId}`
      );
      setUserBadges(response.data);
    } catch (error) {
      console.error("Error fetching badges:", error);
    } finally {
      setLoadingBadges(false);
    }
  };

  // Add function to save selected badges
  const saveSelectedBadges = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        { selectedBadges },
        { headers: { Authorization: `Bearer ${userData.token}` } }
      );
      alert("✅ Badge selection saved!");
    } catch (error) {
      console.error("Error saving badges:", error);
      alert("❌ Failed to save badge selection");
    }
  };

  // Fetch user on mount
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
          {
            headers: { Authorization: `Bearer ${userData.token}` },
          }
        );
        const userDataResponse = res.data;
        const interestsArr = userDataResponse.interests || [];

        // Check if professorInstitution is a custom value (not in the dropdown options)
        const isCustomInstitution =
          userDataResponse.professorInstitution &&
          !institutionOptions.find(
            (opt) => opt.value === userDataResponse.professorInstitution
          );

        setFormData({
          ...userDataResponse,
          firstName: userDataResponse.name
            ? userDataResponse.name.split(" ")[0]
            : "",
          lastName: userDataResponse.name
            ? userDataResponse.name.split(" ").slice(1).join(" ")
            : "",
          interests: userDataResponse.interests || [],
          preferredCountries: userDataResponse.preferredCountries || [],
          professorInstitution: isCustomInstitution
            ? "Other"
            : userDataResponse.professorInstitution,
          customInstitution: isCustomInstitution
            ? userDataResponse.professorInstitution
            : "",
        });

        //Set interests fields
        setInterestsText(interestsArr.join(", "));

        // Handle education array
        if (
          userDataResponse.education &&
          userDataResponse.education.length > 0
        ) {
          const processedEducation = userDataResponse.education.map(
            (entry) => ({
              ...entry,
              customInstitution: entry.customInstitution || "",
            })
          );
          setEducationEntries(processedEducation);
        }
        // Set selected badges
        setSelectedBadges(userDataResponse.selectedBadges || []);

        // If resumeKey exists, fetch presigned link
        if (userDataResponse.resumeKey) {
          const linkRes = await axios.get(
            `${process.env.REACT_APP_FASTAPI_URL}/get-resume-link`,
            {
              params: { file_key: userDataResponse.resumeKey },
            }
          );
          setResumeLink(linkRes.data.url);
        }

        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/referrals/`,
          {
            headers: { Authorization: `Bearer ${userData.token}` },
          }
        );

        setReferralLink(data.referralLink);
        setReferralStats(data.stats);

        setIsVisible(userDataResponse.activelyApplying);
      } catch (err) {
        console.error(err);
        alert("Failed to load profile");
      }
    };

    fetchUser();
    fetchUserBadges(); // Fetch badges
  }, [userId, userData.token]);

  // useEffect(() => {

  //   if(userData?.activelyApplying !== undefined) {
  //     setIsVisible(userData.activelyApplying);
  //   }

  // }, [userData.activelyApplying]);

  // Add helper functions for education management
  const addEducationEntry = () => {
    setEducationEntries((prev) => {
      const levelSequence = ["undergraduate", "masters", "phd"];
      const nextLevel = levelSequence[prev.length] || "phd"; // defaults to phd if beyond the sequence

      return [
        ...prev,
        {
          level: nextLevel,
          institution: "",
          department: "",
          customDepartment: "",
          customInstitution: "",
          gpa: "",
          gpaScale: "",
          graduationYear: "",
          isCompleted: false,
        },
      ];
    });
  };
  const updateEducationEntry = (index, field, value) => {
    setEducationEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };
  const removeEducationEntry = (index) => {
    if (educationEntries.length > 1) {
      setEducationEntries((prev) => prev.filter((_, i) => i !== index));
    }
  };

  // Add badge icon function
  const getBadgeIcon = (icon) => {
    switch (icon) {
      case "star":
        return "⭐";
      case "trophy":
        return "🏆";
      case "medal":
        return "🏅";
      case "fire":
        return "🔥";
      case "heart":
        return "❤️";
      case "crown":
        return "👑";
      case "gem":
        return "💎";
      case "rocket":
        return "🚀";
      default:
        return "🏅";
    }
  };

  // Add badge toggle function
  const toggleBadgeSelection = (badgeId) => {
    setSelectedBadges((prev) => {
      if (prev.includes(badgeId)) {
        return prev.filter((id) => id !== badgeId);
      } else if (prev.length < 3) {
        return [...prev, badgeId];
      } else {
        // Replace the first selected badge if already at limit
        return [prev[1], prev[2], badgeId];
      }
    });
  };

  // Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firstName" || name === "lastName") {
      const firstName = name === "firstName" ? value : formData.firstName;
      const lastName = name === "lastName" ? value : formData.lastName;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        name: `${firstName} ${lastName}`.trim(),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Save updated profile
  const handleSave = async () => {
    try {
      const profileCompleted = isProfileComplete();
      // Remove any incorrect profileCompleted from formData and clean the data
      const { profileCompleted: _, ...cleanFormData } = formData;

      // Helper function to convert and validate numeric fields
      const parseNumber = (value, min, max) => {
        if (!value || value === "") return undefined;
        const num = parseFloat(value);
        if (isNaN(num)) return undefined;
        if (min !== undefined && num < min) return undefined;
        if (max !== undefined && num > max) return undefined;
        return num;
      };

      const parseInt = (value, min, max) => {
        if (!value || value === "") return undefined;
        const num = Number.parseInt(value);
        if (isNaN(num)) return undefined;
        if (min !== undefined && num < min) return undefined;
        if (max !== undefined && num > max) return undefined;
        return num;
      };

      // Initialize sanitizedData here first
      const sanitizedData = {
        profileCompleted,
      };

      // Handle education array - ADD THIS SECTION HERE
      if (Array.isArray(educationEntries) && educationEntries.length > 0) {
        sanitizedData.education = educationEntries
          .map((entry) => ({
            level: entry.level,
            institution:
              entry.institution === "Other"
                ? entry.customInstitution?.trim() || ""
                : entry.institution?.trim() || "",
            department: entry.department?.trim() || "",
            customDepartment:
              entry.department === "other"
                ? entry.customDepartment?.trim()
                : "",
            gpa: parseNumber(entry.gpa, 0),
            gpaScale: ["4.0", "5.0", "10.0", "100", ""].includes(entry.gpaScale)
              ? entry.gpaScale
              : "",
            graduationYear: entry.graduationYear
              ? parseInt(entry.graduationYear)
              : undefined,
            isCompleted: Boolean(entry.isCompleted),
          }))
          .filter((entry) => {
            const hasInstitution = entry.institution;
            const hasDepartment = entry.department;
            const hasCustomDepartment =
              entry.department === "other" ? entry.customDepartment : true;
            return hasInstitution && hasDepartment && hasCustomDepartment;
          }); // Only save entries with required fields
      }

      // Add string fields only if they have valid values
      if (cleanFormData.name?.trim())
        sanitizedData.name = cleanFormData.name.trim();
      if (cleanFormData.email?.trim())
        sanitizedData.email = cleanFormData.email.trim();
      if (cleanFormData.firstName?.trim())
        sanitizedData.firstName = cleanFormData.firstName.trim();
      if (cleanFormData.lastName?.trim())
        sanitizedData.lastName = cleanFormData.lastName.trim();
      if (cleanFormData.firstLanguage?.trim())
        sanitizedData.firstLanguage = cleanFormData.firstLanguage.trim();
      if (cleanFormData.citizenship?.trim())
        sanitizedData.citizenship = cleanFormData.citizenship.trim();
      if (cleanFormData.linkedinUrl?.trim())
        sanitizedData.linkedinUrl = cleanFormData.linkedinUrl.trim();
      if (cleanFormData.resumeKey?.trim())
        sanitizedData.resumeKey = cleanFormData.resumeKey.trim();
      if (cleanFormData.professorInstitution?.trim()) {
        // If "Other" is selected, use the custom institution value
        if (
          cleanFormData.professorInstitution === "Other" &&
          cleanFormData.customInstitution?.trim()
        ) {
          sanitizedData.professorInstitution =
            cleanFormData.customInstitution.trim();
        } else {
          sanitizedData.professorInstitution =
            cleanFormData.professorInstitution.trim();
        }
      }
      if (cleanFormData.professorDepartment?.trim())
        sanitizedData.professorDepartment =
          cleanFormData.professorDepartment.trim();
      if (cleanFormData.professorCollege?.trim())
        sanitizedData.professorCollege = cleanFormData.professorCollege.trim();
      if (cleanFormData.professorRank?.trim())
        sanitizedData.professorRank = cleanFormData.professorRank.trim();
      if (cleanFormData.professorWebPage?.trim())
        sanitizedData.professorWebPage = cleanFormData.professorWebPage.trim();

      // Handle gender (enum field)
      if (
        cleanFormData.gender &&
        ["male", "female", "other", ""].includes(cleanFormData.gender)
      ) {
        sanitizedData.gender = cleanFormData.gender;
      }

      // Handle role (enum field)
      if (
        cleanFormData.role &&
        ["student", "professor", "admin"].includes(cleanFormData.role)
      ) {
        sanitizedData.role = cleanFormData.role;
      }

      // Handle arrays
      if (Array.isArray(cleanFormData.interests)) {
        sanitizedData.interests = cleanFormData.interests;
      }
      if (Array.isArray(cleanFormData.fields)) {
        sanitizedData.fields = cleanFormData.fields;
      }
      if (Array.isArray(cleanFormData.selectedBadges)) {
        sanitizedData.selectedBadges = cleanFormData.selectedBadges;
      }

      const interestsArray = interestsText
        .split(",")
        .map((i) => i.trim())
        .filter((i) => i);
      sanitizedData.interests = interestsArray;

      // Handle preferred countries
      if (Array.isArray(cleanFormData.preferredCountries)) {
        sanitizedData.preferredCountries = cleanFormData.preferredCountries;
      }

      // Handle date
      if (cleanFormData.dob) {
        const date = new Date(cleanFormData.dob);
        if (!isNaN(date.getTime())) {
          sanitizedData.dob = date;
        }
      }

      // Handle numeric fields with validation (remove the old institution/department/gpa fields)
      const greVerbal = parseInt(cleanFormData.greVerbal, 130, 170);
      if (greVerbal !== undefined) sanitizedData.greVerbal = greVerbal;

      const greQuantitative = parseInt(cleanFormData.greQuantitative, 130, 170);
      if (greQuantitative !== undefined)
        sanitizedData.greQuantitative = greQuantitative;

      const greWriting = parseNumber(cleanFormData.greWriting, 0, 6);
      if (greWriting !== undefined) sanitizedData.greWriting = greWriting;

      const toeflReading = parseNumber(cleanFormData.toeflReading, 0, 30);
      if (toeflReading !== undefined) sanitizedData.toeflReading = toeflReading;

      const toeflListening = parseNumber(cleanFormData.toeflListening, 0, 30);
      if (toeflListening !== undefined)
        sanitizedData.toeflListening = toeflListening;

      const toeflSpeaking = parseNumber(cleanFormData.toeflSpeaking, 0, 30);
      if (toeflSpeaking !== undefined)
        sanitizedData.toeflSpeaking = toeflSpeaking;

      const toeflWriting = parseNumber(cleanFormData.toeflWriting, 0, 30);
      if (toeflWriting !== undefined) sanitizedData.toeflWriting = toeflWriting;

      const ieltsListening = parseNumber(cleanFormData.ieltsListening, 0, 9);
      if (ieltsListening !== undefined)
        sanitizedData.ieltsListening = ieltsListening;

      const ieltsReading = parseNumber(cleanFormData.ieltsReading, 0, 9);
      if (ieltsReading !== undefined) sanitizedData.ieltsReading = ieltsReading;

      const ieltsWriting = parseNumber(cleanFormData.ieltsWriting, 0, 9);
      if (ieltsWriting !== undefined) sanitizedData.ieltsWriting = ieltsWriting;

      const ieltsSpeaking = parseNumber(cleanFormData.ieltsSpeaking, 0, 9);
      if (ieltsSpeaking !== undefined)
        sanitizedData.ieltsSpeaking = ieltsSpeaking;

      const ieltsOverall = parseNumber(cleanFormData.ieltsOverall, 0, 9);
      if (ieltsOverall !== undefined) sanitizedData.ieltsOverall = ieltsOverall;

      const englishScore = parseNumber(cleanFormData.englishScore);
      if (englishScore !== undefined) sanitizedData.englishScore = englishScore;

      // SECURITY: Removed sensitive user data logging
      logger.log("Profile data sanitized and ready for submission");

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        sanitizedData,
        { headers: { Authorization: `Bearer ${userData.token}` } }
      );

      const updatedUser = { ...userData, profileCompleted };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      alert("✅ Profile updated");
      if (profileCompleted) {
        window.location.href = "/student-dashboard";
      }
    } catch (err) {
      console.error("Full error object:", err);
      console.error("Error response data:", err.response?.data);
      console.error("Error response status:", err.response?.status);
      alert("❌ Update failed");
    }
  };

  const handleResumeUpload = async () => {
    if (!resumeFile || resumeFile.size > 2 * 1024 * 1024) {
      return alert("❌ Resume must be a PDF under 2MB");
    }

    const formDataUpload = new FormData();
    formDataUpload.append("file", resumeFile);

    try {
      const uploadRes = await axios.post(
        `${
          process.env.REACT_APP_FASTAPI_URL
        }/upload-resume?user_id=${userId}&old_file_key=${encodeURIComponent(
          formData.resumeKey || ""
        )}`,
        formDataUpload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const fileKey = uploadRes.data.file_key;

      // Update formData with the new resumeKey
      const updatedFormData = { ...formData, resumeKey: fileKey };
      setFormData(updatedFormData);

      // Calculate profileCompleted using the updated data, not current state
      const profileCompleted =
        updatedFormData.name?.trim() &&
        educationEntries.some((entry) => {
          const hasInstitution = entry.institution?.trim();
          const hasDepartment = entry.department?.trim();
          const hasCustomDepartment =
            entry.department === "other"
              ? entry.customDepartment?.trim()
              : true;
          return hasInstitution && hasDepartment && hasCustomDepartment;
        }) &&
        fileKey?.trim() &&
        updatedFormData.interests?.length > 0;

      // Update user profile with only the necessary fields
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}`,
        {
          resumeKey: fileKey,
          profileCompleted: profileCompleted, // Make sure this is explicitly a boolean
        },
        { headers: { Authorization: `Bearer ${userData.token}` } }
      );

      const updatedUser = { ...userData, profileCompleted };
      localStorage.setItem("user", JSON.stringify(updatedUser));

      // Get resume link for display
      const linkRes = await axios.get(
        `${process.env.REACT_APP_FASTAPI_URL}/get-resume-link`,
        {
          params: { file_key: fileKey },
        }
      );
      setResumeLink(linkRes.data.url);

      alert("📄 Resume uploaded!");
    } catch (err) {
      console.error(err);
      alert("❌ Resume upload failed");
    }
  };

  // Toggle visibility (activelyApplying) for students
  const handleToggleVisibility = async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}/toggleActive`,
        {},
        { headers: { Authorization: `Bearer ${userData.token}` } }
      );

      const newStatus = response.data.activelyApplying;
      setIsVisible(newStatus);

      // Update localStorage
      const updatedUser = { ...userData, activelyApplying: newStatus };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    } catch (err) {
      console.error("Error toggling activelyApplying:", err);
      alert("❌ Failed to update visibility status");
    }
  };

  // Copy referral link to clipboard with feedback
  const copyReferralLink = async () => {
    if (!referralLink) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(referralLink);
      } else {
        // Fallback for older browsers
        const tmp = document.createElement("input");
        tmp.value = referralLink;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand("copy");
        document.body.removeChild(tmp);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy referral link", err);
      alert("Failed to copy referral link");
    }
  };

  return (
    <div className="min-h-screen pb-8" style={{ backgroundColor: "#F4F3EE" }}>
      <div className="max-w-4xl mx-auto p-8">
        <div className="flex items-center mb-8">
          <h1 className="text-4xl font-bold" style={{ color: "#061941" }}>
            My Profile
          </h1>
          <div
            className="flex-grow h-0.5 ml-6"
            style={{ backgroundColor: "#061941" }}
          ></div>
        </div>

        {userData.role === "student" && (
          <div className="flex items-center justify-between bg-white shadow-md rounded-lg p-4 mb-4">
            <div>
              <h2
                className="text-lg font-semibold"
                style={{ color: "#061941" }}
              >
                Visibility Status
              </h2>
              <p className="text-sm text-gray-600">
                {isVisible
                  ? "You are visible to professors as actively searching."
                  : "You are hidden from professors."}
              </p>
            </div>
            <button
              onClick={handleToggleVisibility}
              className={`px-4 py-2 rounded-md font-medium transition-colors duration-200 ${
                isVisible
                  ? "bg-green-600 text-white hover:bg-green-700"
                  : "bg-gray-300 text-gray-700 hover:bg-gray-400"
              }`}
            >
              {isVisible ? "✅ Actively Searching" : "🙈 Not Searching"}
            </button>
          </div>
        )}

        {/* Visibility Status for Professors */}
        {userData.role === "professor" && (
          <div className="flex items-center justify-between bg-white shadow-md rounded-lg p-4 mb-4">
            <div>
              <h2
                className="text-lg font-semibold"
                style={{ color: "#061941" }}
              >
                Visibility Status
              </h2>
              <p className="text-sm text-gray-600">
                {isVisible
                  ? "You are visible to students in the professor pool."
                  : "You are hidden from the professor pool."}
              </p>
            </div>
            <button
              onClick={handleToggleVisibility}
              className={`px-4 py-2 rounded-md font-medium transition-colors duration-200 ${
                isVisible
                  ? "bg-green-600 text-white hover:bg-green-700"
                  : "bg-gray-300 text-gray-700 hover:bg-gray-400"
              }`}
            >
              {isVisible ? "✅ Visible" : "🙈 Hidden"}
            </button>
          </div>
        )}

        {/* Referral link display */}
        {userData.role === "student" && referralLink && (
          <div className="bg-white rounded-lg shadow-md p-5 mb-4">
            <h3 className="text-lg font-semibold text-[#061941] mb-1">
              Referral Link
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Share this link to invite others to Neuhawk and earn rewards.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch gap-3">
              <input
                readOnly
                value={referralLink}
                className="flex-1 px-3 py-2 border rounded-lg text-gray-800 bg-[#F8FAFC] focus:ring-2 focus:ring-blue-500 focus:outline-none transition"
              />

              <div className="flex gap-2">
                <button
                  onClick={copyReferralLink}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                    copied
                      ? "bg-green-500 text-white hover:bg-green-600"
                      : "bg-blue-950 text-white hover:bg-blue-700"
                  }`}
                >
                  {copied ? "Copied!" : "Copy"}
                </button>

                <a
                  href={referralLink}
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-lg border text-gray-700 border-gray-300 hover:bg-gray-100 font-medium transition-colors duration-200"
                >
                  Open
                </a>
              </div>
            </div>

            {/* Referral Statistics */}
            {referralStats && (
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-600">
                      Successful Referrals:
                    </span>
                    <span className="text-lg font-bold text-[#061941]">
                      {referralStats.successfulReferrals}
                    </span>
                  </div>
                  <div className="text-xs text-gray-500">
                    Rewards Earned: {referralStats.rewardsEarned}/5
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/*hi */}

        {/* Before Applying Card */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2
            className="text-2xl font-semibold mb-2"
            style={{ color: "#061941" }}
          >
            Before Applying
          </h2>
          <p className="text-gray-600 mb-2">
            Complete your profile before starting your application. Required
            fields are marked with{" "}
            <span style={{ color: "#EF4444", fontWeight: "bold" }}>*</span>
          </p>
          <div className="flex flex-wrap gap-2 mt-3">
            <span style={getSectionStatusStyle("personal")}>
              {isSectionComplete("personal")
                ? "✓ Personal Info"
                : "✗ Personal Info"}
            </span>
            <span style={getSectionStatusStyle("education")}>
              {isSectionComplete("education") ? "✓ Education" : "✗ Education"}
            </span>
            <span style={getSectionStatusStyle("preferences")}>
              {isSectionComplete("preferences")
                ? "✓ Preferences"
                : "✗ Preferences"}
            </span>
            {userData.role === "student" && (
              <span style={getSectionStatusStyle("resume")}>
                {isSectionComplete("resume") ? "✓ Resume" : "✗ Resume"}
              </span>
            )}
          </div>
        </div>

        {/* Personal Information Card */}
        <div
          className={`bg-white rounded-lg shadow-lg mb-6 ${
            !isSectionComplete("personal") ? "ring-2 ring-red-500" : ""
          }`}
        >
          <div
            className="p-4 rounded-t-lg"
            style={{ backgroundColor: "#061941" }}
          >
            <h2 className="text-xl font-semibold" style={{ color: "#F4F3EE" }}>
              Personal Information{" "}
              <span style={{ color: "#EF4444", fontWeight: "bold" }}>*</span>
            </h2>
          </div>
          <div
            className="p-6"
            style={{
              border: "2px solid #061941",
              borderTop: "none",
              borderBottomLeftRadius: "0.5rem",
              borderBottomRightRadius: "0.5rem",
            }}
          >
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  style={{ color: "#061941" }}
                >
                  First Name{" "}
                  <span style={{ color: "#EF4444", fontWeight: "bold" }}>
                    *
                  </span>
                </label>
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-offset-2 ${
                    !formData.firstName?.trim() ? "border-red-500" : ""
                  }`}
                  style={{
                    borderColor: !formData.firstName?.trim()
                      ? "#EF4444"
                      : "#3C6E71",
                    backgroundColor: "#F4F3EE",
                  }}
                  placeholder="Enter your first name"
                />
                {!formData.firstName?.trim() && (
                  <p className="text-red-500 text-xs mt-1">
                    First name is required
                  </p>
                )}
              </div>
              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  style={{ color: "#061941" }}
                >
                  Last Name{" "}
                  <span style={{ color: "#EF4444", fontWeight: "bold" }}>
                    *
                  </span>
                </label>
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-offset-2 ${
                    !formData.lastName?.trim() ? "border-red-500" : ""
                  }`}
                  style={{
                    borderColor: !formData.lastName?.trim()
                      ? "#EF4444"
                      : "#3C6E71",
                    backgroundColor: "#F4F3EE",
                  }}
                  placeholder="Enter your last name"
                />
                {!formData.lastName?.trim() && (
                  <p className="text-red-500 text-xs mt-1">
                    Last name is required
                  </p>
                )}
              </div>
              {userData.role === "student" && (
                <>
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      style={{ color: "#061941" }}
                    >
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob ? formData.dob.split("T")[0] : ""}
                      onChange={handleChange}
                      className="w-full p-2 border rounded-md"
                      style={{
                        borderColor: "#3C6E71",
                        backgroundColor: "#F4F3EE",
                      }}
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      style={{ color: "#061941" }}
                    >
                      Gender
                    </label>
                    <select
                      name="gender"
                      value={formData.gender || ""}
                      onChange={handleChange}
                      className="w-full p-2 border rounded-md"
                      style={{
                        borderColor: "#3C6E71",
                        backgroundColor: "#F4F3EE",
                      }}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      style={{ color: "#061941" }}
                    >
                      First Language
                    </label>
                    <input
                      name="firstLanguage"
                      value={formData.firstLanguage || ""}
                      onChange={handleChange}
                      className="w-full p-2 border rounded-md"
                      style={{
                        borderColor: "#3C6E71",
                        backgroundColor: "#F4F3EE",
                      }}
                    />
                  </div>
                  <div>
                    <label
                      className="block text-sm font-medium mb-1"
                      style={{ color: "#061941" }}
                    >
                      Country of Citizenship
                    </label>
                    <input
                      name="citizenship"
                      value={formData.citizenship || ""}
                      onChange={handleChange}
                      className="w-full p-2 border rounded-md"
                      style={{
                        borderColor: "#3C6E71",
                        backgroundColor: "#F4F3EE",
                      }}
                    />
                  </div>
                </>
              )}
              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  style={{ color: "#061941" }}
                >
                  LinkedIn Profile URL
                </label>
                <input
                  name="linkedinUrl"
                  value={formData.linkedinUrl || ""}
                  onChange={handleChange}
                  className="w-full p-2 border rounded-md"
                  style={{ borderColor: "#3C6E71", backgroundColor: "#F4F3EE" }}
                  placeholder="https://linkedin.com/in/your-profile"
                />
              </div>
            </div>
          </div>
        </div>
        {/* Education History Card - Only for Students */}
        {userData.role === "student" && (
          <div
            className={`bg-white rounded-lg shadow-lg mb-6 ${
              !isSectionComplete("education") ? "ring-2 ring-red-500" : ""
            }`}
          >
            <div
              className="p-4 rounded-t-lg"
              style={{ backgroundColor: "#061941" }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: "#F4F3EE" }}
              >
                Education History{" "}
                <span style={{ color: "#EF4444", fontWeight: "bold" }}>*</span>
              </h2>
            </div>
            <div
              className="p-6"
              style={{
                border: "2px solid #061941",
                borderTop: "none",
                borderBottomLeftRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
              }}
            >
              {educationEntries.map((entry, index) => (
                <div
                  key={index}
                  className={`mb-6 p-4 border rounded-lg ${
                    !entry.institution?.trim() ||
                    (!entry.department?.trim() && entry.department !== "other")
                      ? "border-red-500 bg-red-50"
                      : "border-gray-200"
                  }`}
                >
                  <div className="flex justify-between items-center mb-4">
                    <h3
                      className="text-lg font-medium capitalize"
                      style={{ color: "#061941" }}
                    >
                      {entry.level} Degree
                    </h3>
                    {educationEntries.length > 1 && (
                      <button
                        onClick={() => removeEducationEntry(index)}
                        className="text-red-600 hover:text-red-800 text-sm"
                      >
                        Remove
                      </button>
                    )}
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Institution{" "}
                        <span style={{ color: "#EF4444", fontWeight: "bold" }}>
                          *
                        </span>
                      </label>
                      <Select
                        options={institutionOptions}
                        value={
                          institutionOptions.find(
                            (opt) => opt.value === entry.institution
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          updateEducationEntry(
                            index,
                            "institution",
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        filterOption={(option, inputValue) => {
                          // Always show "Other" option when user is typing
                          if (option.value === "Other") {
                            return inputValue.length > 0;
                          }
                          // Normal filtering for other options
                          return option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase());
                        }}
                        noOptionsMessage={({ inputValue }) => {
                          // Show "Other" option when no matches found and user has typed something
                          if (inputValue && inputValue.length > 0) {
                            return 'Type to search or select "Other"';
                          }
                          return "No options found";
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#F4F3EE",
                            borderColor: !entry.institution?.trim()
                              ? "#EF4444"
                              : "#3C6E71",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#061941"
                              : state.isFocused
                              ? "#E5E7EB"
                              : "#FFFFFF",
                            color: state.isSelected ? "#FFFFFF" : "#061941",
                            "&:hover": {
                              backgroundColor: state.isSelected
                                ? "#061941"
                                : "#E5E7EB",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "#061941",
                          }),
                        }}
                        placeholder="Select your institution"
                        isSearchable
                      />
                      {entry.institution === "Other" && (
                        <div className="mt-2">
                          <input
                            type="text"
                            placeholder="Enter your university name"
                            value={entry.customInstitution || ""}
                            onChange={(e) =>
                              updateEducationEntry(
                                index,
                                "customInstitution",
                                e.target.value
                              )
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            style={{
                              backgroundColor: "#F4F3EE",
                              borderColor: "#3C6E71",
                            }}
                          />
                          {!entry.customInstitution?.trim() && (
                            <p className="text-red-500 text-xs mt-1">
                              Please enter your university name
                            </p>
                          )}
                        </div>
                      )}
                      {!entry.institution?.trim() && (
                        <p className="text-red-500 text-xs mt-1">
                          Institution is required
                        </p>
                      )}
                    </div>

                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Department/Major
                      </label>
                      <Select
                        options={majorsOptions}
                        value={
                          majorsOptions.find(
                            (opt) => opt.value === entry.department
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          updateEducationEntry(
                            index,
                            "department",
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        filterOption={(option, inputValue) => {
                          // Always show "Other" option when user is typing
                          if (option.value === "other") {
                            return inputValue.length > 0;
                          }
                          // Normal filtering for other options
                          return option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase());
                        }}
                        noOptionsMessage={({ inputValue }) => {
                          // Show "Other" option when no matches found and user has typed something
                          if (inputValue && inputValue.length > 0) {
                            return 'Type to search or select "Other"';
                          }
                          return "No options found";
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#F4F3EE",
                            borderColor: !entry.department?.trim()
                              ? "#EF4444"
                              : "#3C6E71",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#061941"
                              : state.isFocused
                              ? "#E5E7EB"
                              : "#FFFFFF",
                            color: state.isSelected ? "#FFFFFF" : "#061941",
                            "&:hover": {
                              backgroundColor: state.isSelected
                                ? "#061941"
                                : "#E5E7EB",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "#061941",
                          }),
                        }}
                        placeholder="Select your major or choose Other"
                        isSearchable
                      />
                      {!entry.department?.trim() && (
                        <p className="text-red-500 text-xs mt-1">
                          Department/Major is required
                        </p>
                      )}
                      {isDepartmentOther(entry.department) && (
                        <div className="mt-3">
                          <label
                            className="block text-sm font-medium mb-1"
                            style={{ color: "#061941" }}
                          >
                            Specify Your Major
                          </label>
                          <input
                            value={entry.customDepartment || ""}
                            onChange={(e) =>
                              updateEducationEntry(
                                index,
                                "customDepartment",
                                e.target.value
                              )
                            }
                            className="w-full p-2 border rounded-md"
                            style={{
                              borderColor: "#3C6E71",
                              backgroundColor: "#F4F3EE",
                            }}
                            placeholder="Enter your specific major (e.g., Marine Biology, Digital Arts)"
                          />
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label
                          className="block text-sm font-medium mb-1"
                          style={{ color: "#061941" }}
                        >
                          Graduation Year
                        </label>
                        <input
                          type="number"
                          value={entry.graduationYear}
                          onChange={(e) =>
                            updateEducationEntry(
                              index,
                              "graduationYear",
                              e.target.value
                            )
                          }
                          className="w-full p-2 border rounded-md"
                          style={{
                            borderColor: "#3C6E71",
                            backgroundColor: "#F4F3EE",
                          }}
                          placeholder="e.g., 2024"
                        />
                      </div>
                      <div>
                        <label
                          className="block text-sm font-medium mb-1"
                          style={{ color: "#061941" }}
                        >
                          GPA
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          value={entry.gpa}
                          onChange={(e) =>
                            updateEducationEntry(index, "gpa", e.target.value)
                          }
                          className="w-full p-2 border rounded-md"
                          style={{
                            borderColor: "#3C6E71",
                            backgroundColor: "#F4F3EE",
                          }}
                          placeholder="e.g., 3.85"
                          min="0"
                          max="5"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]*"
                        />
                      </div>
                      <div>
                        <label
                          className="block text-sm font-medium mb-1"
                          style={{ color: "#061941" }}
                        >
                          GPA Scale
                        </label>
                        <select
                          value={entry.gpaScale}
                          onChange={(e) =>
                            updateEducationEntry(
                              index,
                              "gpaScale",
                              e.target.value
                            )
                          }
                          className="w-full p-2 border rounded-md"
                          style={{
                            borderColor: "#3C6E71",
                            backgroundColor: "#F4F3EE",
                          }}
                        >
                          <option value="">Select Scale</option>
                          <option value="4.0">4.0</option>
                          <option value="5.0">5.0</option>
                          <option value="10.0">10.0</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={entry.isCompleted}
                          onChange={(e) =>
                            updateEducationEntry(
                              index,
                              "isCompleted",
                              e.target.checked
                            )
                          }
                          className="mr-2"
                        />
                        <span className="text-sm" style={{ color: "#061941" }}>
                          Completed
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              ))}

              <button
                onClick={addEducationEntry}
                className="w-full py-2 border-2 border-dashed rounded-md text-center transition-colors duration-200 hover:bg-gray-50"
                style={{ borderColor: "#3C6E71", color: "#3C6E71" }}
              >
                + Add Education Entry
              </button>
            </div>
          </div>
        )}

        {/* Professor Information Card - Only for Professors */}
        {userData.role === "professor" && (
          <div
            className={`bg-white rounded-lg shadow-lg mb-6 ${
              !isSectionComplete("professorInfo") ? "ring-2 ring-red-500" : ""
            }`}
          >
            <div
              className="p-4 rounded-t-lg"
              style={{ backgroundColor: "#061941" }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: "#F4F3EE" }}
              >
                Professor Information
              </h2>
            </div>
            <div
              className="p-6"
              style={{
                border: "2px solid #061941",
                borderTop: "none",
                borderBottomLeftRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
              }}
            >
              <div className="space-y-4">
                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    style={{ color: "#061941" }}
                  >
                    Institution
                  </label>
                  {formData.professorInstitution === "Other" ? (
                    <div>
                      <input
                        type="text"
                        value={formData.customInstitution || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customInstitution: e.target.value,
                          })
                        }
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                          minHeight: "40px",
                        }}
                        placeholder="Enter your institution name"
                        onFocus={(e) =>
                          (e.target.style.borderColor = "#061941")
                        }
                        onBlur={(e) => (e.target.style.borderColor = "#3C6E71")}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setFormData({
                            ...formData,
                            professorInstitution: "",
                            customInstitution: "",
                          })
                        }
                        style={{
                          marginTop: "4px",
                          fontSize: "12px",
                          color: "#3C6E71",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        ← Back to dropdown
                      </button>
                    </div>
                  ) : (
                    <Select
                      options={institutionOptions}
                      value={
                        institutionOptions.find(
                          (opt) => opt.value === formData.professorInstitution
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        if (
                          selectedOption &&
                          selectedOption.value === "Other"
                        ) {
                          setFormData({
                            ...formData,
                            professorInstitution: "Other",
                            customInstitution: "",
                          });
                        } else {
                          setFormData({
                            ...formData,
                            professorInstitution: selectedOption
                              ? selectedOption.value
                              : "",
                            customInstitution: "",
                          });
                        }
                      }}
                      filterOption={(option, inputValue) => {
                        // Always show "Other" option when user is typing
                        if (option.value === "Other") {
                          return inputValue.length > 0;
                        }
                        // Normal filtering for other options
                        return option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase());
                      }}
                      noOptionsMessage={({ inputValue }) => {
                        // Show "Other" option when no matches found and user has typed something
                        if (inputValue && inputValue.length > 0) {
                          return 'Type to search or select "Other"';
                        }
                        return "No options found";
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "40px",
                          borderColor: state.isFocused ? "#061941" : "#3C6E71",
                          backgroundColor: "#F4F3EE",
                          boxShadow: state.isFocused
                            ? "0 0 0 1px #061941"
                            : "none",
                          "&:hover": {
                            borderColor: "#061941",
                          },
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected
                            ? "#061941"
                            : state.isFocused
                            ? "#06194122"
                            : "white",
                          color: state.isSelected ? "white" : "#061941",
                          "&:hover": {
                            backgroundColor: state.isSelected
                              ? "#061941"
                              : "#06194122",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: "#061941",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "#3C6E71",
                        }),
                      }}
                      placeholder="Select Institution"
                      isClearable
                      isSearchable
                    />
                  )}
                </div>

                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    style={{ color: "#061941" }}
                  >
                    College/School
                  </label>
                  <input
                    type="text"
                    value={formData.professorCollege}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        professorCollege: e.target.value,
                      })
                    }
                    className="w-full p-2 border rounded-md"
                    style={{
                      borderColor: "#3C6E71",
                      backgroundColor: "#F4F3EE",
                    }}
                    placeholder="e.g., School of Engineering"
                  />
                </div>

                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    style={{ color: "#061941" }}
                  >
                    Department
                  </label>
                  <input
                    type="text"
                    value={formData.professorDepartment}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        professorDepartment: e.target.value,
                      })
                    }
                    className="w-full p-2 border rounded-md"
                    style={{
                      borderColor: "#3C6E71",
                      backgroundColor: "#F4F3EE",
                    }}
                    placeholder="e.g., Computer Science"
                  />
                </div>

                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    style={{ color: "#061941" }}
                  >
                    Academic Rank
                  </label>
                  <select
                    value={formData.professorRank}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        professorRank: e.target.value,
                      })
                    }
                    className="w-full p-2 border rounded-md"
                    style={{
                      borderColor: "#3C6E71",
                      backgroundColor: "#F4F3EE",
                    }}
                  >
                    <option value="">Select your rank</option>
                    <option value="Assistant Professor">
                      Assistant Professor
                    </option>
                    <option value="Associate Professor">
                      Associate Professor
                    </option>
                    <option value="Full Professor">Full Professor</option>
                    <option value="Professor Emeritus">
                      Professor Emeritus
                    </option>
                    <option value="Lecturer">Lecturer</option>
                    <option value="Senior Lecturer">Senior Lecturer</option>
                    <option value="Research Professor">
                      Research Professor
                    </option>
                    <option value="Adjunct Professor">Adjunct Professor</option>
                    <option value="Visiting Professor">
                      Visiting Professor
                    </option>
                    <option value="Postdoctoral Researcher">
                      Postdoctoral Researcher
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    style={{ color: "#061941" }}
                  >
                    Personal/Research Web Page
                  </label>
                  <input
                    type="url"
                    value={formData.professorWebPage}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        professorWebPage: e.target.value,
                      })
                    }
                    className="w-full p-2 border rounded-md"
                    style={{
                      borderColor: "#3C6E71",
                      backgroundColor: "#F4F3EE",
                    }}
                    placeholder="https://your-website.com"
                  />
                  <p className="text-xs text-gray-600 mt-1">
                    Link to your personal website, research lab page, or
                    academic profile
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Test Scores Card - Students Only */}
        {userData.role === "student" && (
          <div className="bg-white rounded-lg shadow-lg mb-6">
            <div
              className="p-4 rounded-t-lg"
              style={{ backgroundColor: "#061941" }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: "#F4F3EE" }}
              >
                Test Scores
              </h2>
            </div>
            <div
              className="p-6"
              style={{
                border: "2px solid #061941",
                borderTop: "none",
                borderBottomLeftRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
              }}
            >
              <div className="space-y-6">
                {/* GRE Scores Section */}
                <div>
                  <h3
                    className="text-lg font-semibold mb-3"
                    style={{ color: "#061941" }}
                  >
                    GRE Scores
                  </h3>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Verbal
                      </label>
                      <input
                        type="number"
                        name="greVerbal"
                        value={formData.greVerbal || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="130-170"
                        min="130"
                        max="170"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Quantitative
                      </label>
                      <input
                        type="number"
                        name="greQuantitative"
                        value={formData.greQuantitative || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="130-170"
                        min="130"
                        max="170"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Writing
                      </label>
                      <input
                        type="number"
                        step="0.5"
                        name="greWriting"
                        value={formData.greWriting || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0.0-6.0"
                        min="0"
                        max="6"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                  </div>
                </div>

                {/* TOEFL Scores Section */}
                <div>
                  <h3
                    className="text-lg font-semibold mb-3"
                    style={{ color: "#061941" }}
                  >
                    TOEFL Scores
                  </h3>
                  <div className="grid grid-cols-4 gap-4">
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Reading
                      </label>
                      <input
                        type="number"
                        name="toeflReading"
                        value={formData.toeflReading || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-30"
                        min="0"
                        max="30"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Listening
                      </label>
                      <input
                        type="number"
                        name="toeflListening"
                        value={formData.toeflListening || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-30"
                        min="0"
                        max="30"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Speaking
                      </label>
                      <input
                        type="number"
                        name="toeflSpeaking"
                        value={formData.toeflSpeaking || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-30"
                        min="0"
                        max="30"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Writing
                      </label>
                      <input
                        type="number"
                        name="toeflWriting"
                        value={formData.toeflWriting || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-30"
                        min="0"
                        max="30"
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>
                </div>

                {/* IELTS Scores Section */}
                <div>
                  <h3
                    className="text-lg font-semibold mb-3"
                    style={{ color: "#061941" }}
                  >
                    IELTS Scores
                  </h3>
                  <div className="grid grid-cols-5 gap-4">
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Listening
                      </label>
                      <input
                        type="number"
                        name="ieltsListening"
                        value={formData.ieltsListening || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-9"
                        min="0"
                        max="9"
                        step="0.5"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Reading
                      </label>
                      <input
                        type="number"
                        name="ieltsReading"
                        value={formData.ieltsReading || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-9"
                        min="0"
                        max="9"
                        step="0.5"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Writing
                      </label>
                      <input
                        type="number"
                        name="ieltsWriting"
                        value={formData.ieltsWriting || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-9"
                        min="0"
                        max="9"
                        step="0.5"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Speaking
                      </label>
                      <input
                        type="number"
                        name="ieltsSpeaking"
                        value={formData.ieltsSpeaking || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-9"
                        min="0"
                        max="9"
                        step="0.5"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                    <div>
                      <label
                        className="block text-sm font-medium mb-1"
                        style={{ color: "#061941" }}
                      >
                        Overall
                      </label>
                      <input
                        type="number"
                        name="ieltsOverall"
                        value={formData.ieltsOverall || ""}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-md"
                        style={{
                          borderColor: "#3C6E71",
                          backgroundColor: "#F4F3EE",
                        }}
                        placeholder="0-9"
                        min="0"
                        max="9"
                        step="0.5"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Preferences Card */}
        <div
          className={`bg-white rounded-lg shadow-lg mb-6 ${
            !isSectionComplete("preferences") ? "ring-2 ring-red-500" : ""
          }`}
        >
          <div
            className="p-4 rounded-t-lg"
            style={{ backgroundColor: "#061941" }}
          >
            <h2 className="text-xl font-semibold" style={{ color: "#F4F3EE" }}>
              Preferences
            </h2>
          </div>
          <div
            className="p-6"
            style={{
              border: "2px solid #061941",
              borderTop: "none",
              borderBottomLeftRadius: "0.5rem",
              borderBottomRightRadius: "0.5rem",
            }}
          >
            <div className="space-y-4">
              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  style={{ color: "#061941" }}
                >
                  Research Interests
                </label>
                <input
                  name="interestsText"
                  value={interestsText}
                  onChange={(e) => setInterestsText(e.target.value)}
                  className="w-full p-2 border rounded-md"
                  style={{ borderColor: "#3C6E71", backgroundColor: "#F4F3EE" }}
                  placeholder="Enter interests separated by commas"
                />
              </div>

              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  style={{ color: "#061941" }}
                >
                  Preferred Countries
                </label>
                <Select
                  options={countriesOptions}
                  value={countriesOptions.filter((opt) =>
                    formData.preferredCountries.includes(opt.value)
                  )}
                  onChange={(selectedOptions) => {
                    const selectedValues = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];
                    setFormData({
                      ...formData,
                      preferredCountries: selectedValues,
                    });
                  }}
                  isMulti
                  isClearable
                  isSearchable
                  placeholder="Select preferred countries for positions"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "40px",
                      borderColor: state.isFocused ? "#061941" : "#3C6E71",
                      backgroundColor: "#F4F3EE",
                      boxShadow: state.isFocused ? "0 0 0 1px #061941" : "none",
                      "&:hover": {
                        borderColor: "#061941",
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? "#061941"
                        : state.isFocused
                        ? "#06194122"
                        : "white",
                      color: state.isSelected ? "white" : "#061941",
                      "&:hover": {
                        backgroundColor: state.isSelected
                          ? "#061941"
                          : "#06194122",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: "#06194122",
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: "#061941",
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#061941",
                      "&:hover": {
                        backgroundColor: "#061941",
                        color: "white",
                      },
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#3C6E71",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Resume Upload Section */}
        {userData.role === "student" && (
          <div className="bg-white rounded-lg shadow-lg mb-6">
            <div
              className="p-4 rounded-t-lg"
              style={{ backgroundColor: "#061941" }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: "#F4F3EE" }}
              >
                Resume Upload
              </h2>
            </div>
            <div
              className="p-6"
              style={{
                border: "2px solid #061941",
                borderTop: "none",
                borderBottomLeftRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
              }}
            >
              <label
                className="block text-sm font-medium mb-3"
                style={{ color: "#061941" }}
              >
                Upload Resume (PDF, max 2MB)
              </label>
              <input
                type="file"
                accept=".pdf"
                onChange={(e) => setResumeFile(e.target.files[0])}
                className="block mb-4"
              />
              <button
                onClick={handleResumeUpload}
                className="px-6 py-2 rounded-md text-white font-medium transition-colors duration-200 hover:opacity-90"
                style={{ backgroundColor: "#3C6E71" }}
              >
                Upload Resume
              </button>
              {resumeLink && (
                <p className="text-sm mt-3">
                  📎{" "}
                  <a
                    href={resumeLink}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#061941" }}
                    className="hover:underline"
                  >
                    View Uploaded Resume
                  </a>
                </p>
              )}
            </div>
          </div>
        )}

        {/* Badge Selection Card - Only for Students */}
        {userData.role === "student" && (
          <div className="bg-white rounded-lg shadow-lg mb-6">
            <div
              className="p-4 rounded-t-lg"
              style={{ backgroundColor: "#061941" }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: "#F4F3EE" }}
              >
                Badge Display Settings
              </h2>
            </div>
            <div
              className="p-6"
              style={{
                border: "2px solid #061941",
                borderTop: "none",
                borderBottomLeftRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
              }}
            >
              <div className="space-y-4">
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: "#061941" }}
                  >
                    Select badges to display on your profile card (up to 3)
                  </label>
                  <p className="text-sm text-gray-600 mb-4">
                    Choose which badges you want to show on your student card
                    when others view your profile.
                  </p>
                </div>

                {loadingBadges ? (
                  <div className="text-center py-4">
                    <div className="text-gray-500">Loading your badges...</div>
                  </div>
                ) : userBadges.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {userBadges.map((userBadge) => (
                      <div
                        key={userBadge._id}
                        className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                          selectedBadges.includes(userBadge.badgeId._id)
                            ? "border-blue-500 bg-blue-50"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() =>
                          toggleBadgeSelection(userBadge.badgeId._id)
                        }
                      >
                        <div className="flex items-center space-x-3">
                          <div
                            className="w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md"
                            style={{ backgroundColor: userBadge.badgeId.color }}
                          >
                            {getBadgeIcon(userBadge.badgeId.icon)}
                          </div>
                          <div className="flex-1">
                            <h3 className="font-semibold text-gray-800">
                              {userBadge.badgeId.name}
                            </h3>
                            <p className="text-sm text-gray-600">
                              {userBadge.badgeId.description}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              Earned:{" "}
                              {new Date(
                                userBadge.awardedAt
                              ).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="flex-shrink-0">
                            {selectedBadges.includes(userBadge.badgeId._id) && (
                              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-sm">✓</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <div className="text-lg mb-2">No badges earned yet</div>
                    <p className="text-sm">
                      Complete activities to earn badges that you can display on
                      your profile!
                    </p>
                  </div>
                )}

                {userBadges.length > 0 && (
                  <div className="flex justify-between items-center pt-4 border-t">
                    <div className="text-sm text-gray-600">
                      {selectedBadges.length} of 3 badges selected
                    </div>
                    <button
                      onClick={saveSelectedBadges}
                      className="px-4 py-2 rounded-md text-white font-medium transition-colors duration-200 hover:opacity-90"
                      style={{ backgroundColor: "#3C6E71" }}
                      disabled={selectedBadges.length > 3}
                    >
                      Save Badge Selection
                    </button>
                  </div>
                )}

                {selectedBadges.length > 3 && (
                  <div className="text-red-600 text-sm">
                    Please select only 3 badges to display on your profile card.
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Start Applying Card - Only for Students */}
        {userData.role === "student" && (
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <h2
              className="text-2xl font-semibold mb-2"
              style={{ color: "#061941" }}
            >
              Start Applying
            </h2>
            <button
              className={`px-6 py-2 rounded-md text-white font-medium transition-all duration-300 ${
                isProfileComplete()
                  ? "hover:opacity-90"
                  : "opacity-50 cursor-not-allowed"
              }`}
              style={{
                backgroundColor: "#061941",
                filter: isProfileComplete() ? "none" : "blur(1px)",
              }}
              onClick={() => {
                if (isProfileComplete()) {
                  navigate("/student-dashboard");
                } else {
                  alert("Please complete all required fields first");
                }
              }}
              disabled={!isProfileComplete()}
            >
              Find a Program
            </button>
          </div>
        )}

        {/* Save Buttons */}
        <div className="flex justify-end gap-4">
          <button
            onClick={handleSave}
            className="px-8 py-3 rounded-md text-white font-medium transition-colors duration-200 hover:opacity-90"
            style={{ backgroundColor: "#061941", border: "2px solid #061941" }}
          >
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  );
}
